import React, { useState, useEffect } from 'react';
import { Typography, Table, TableHead, TableCell, TableRow, TableBody, TableContainer, TablePagination, Grid, Button, LinearProgress } from '@mui/material';
import html2pdf from 'html2pdf.js';
import { Paper, Box, Card, CardContent, Stack } from '@mui/material';
import config from '../config.json';
import { apiRequest } from '../functions/apiRequest';
import { generateHtmlForPdf } from '../functions/certificate';

const userID = parseInt(localStorage.getItem("userID"));

function tableBod(data, type, fontSize) {
  let returnTableBody = [];
  for (let index = 0; index < data.length; index++) {
    if (data[index].Credit > 0) {
      returnTableBody.push(
        <TableRow key={index}>
          <TableCell >
            <Typography style={{ fontSize: fontSize }}>{data[index].ProgramName}</Typography>
          </TableCell>
          <TableCell >
            <Typography style={{ fontSize: fontSize }}>{data[index].EventName}</Typography>
          </TableCell>
          <TableCell >
            <Typography style={{ fontSize: fontSize }}>{data[index].EventDate}</Typography>
          </TableCell>
          <TableCell >
            <Typography style={{ fontSize: fontSize }}> {data[index].Credit}</Typography>
          </TableCell>
        </TableRow>
      );
    }
  }
  return returnTableBody;
}

function DataTable(props) {

  const [data, setCredorDebitData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalValue, setTotalValue] = useState(0);
  const [certificateData, setCertificateData] = useState([]);
  const firstName = localStorage.getItem('first_name');
  const [isLoading, setIsLoading] = useState(true);
  const [fontSize, setFontSize] = useState('14px');

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    setCredorDebitData(getCreditorDebitDetails(props.type));
    if (window.innerWidth < 900) {
      setFontSize('12px')
    }
    // eslint-disable-next-line
  }, []);

  async function getCreditorDebitDetails(type) {
    try {
      const data = await apiRequest('get', false, `/cred/data?user_id=${userID}`)
      let count = 0;
      setCredorDebitData(data);
      if (parseInt(type) === 1) {
        data.forEach((i) => {
          count = count + i.Credit;
        });
        setTotalValue(count);
      } else {
        data.forEach((i) => {
          count = count + i.Debit;
        });
        setTotalValue(count);
      }
      setIsLoading(false);
    } catch (err) {
      //console.log(er);
    }
  }

  // Function to convert image URL to Base64
  async function imageUrlToBase64(url) {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  async function convertImagesToBase64(element) {
    const imageElements = element.getElementsByTagName('img');
    for (const img of imageElements) {
      const imageUrl = img.src;
      try {
        const base64Data = await imageUrlToBase64(imageUrl);
        img.src = base64Data;
      } catch (err) {

      }
    }
  }

  async function getCertificateData(programView) {
    try {
      const token = localStorage.getItem('token');
      let endPoint = `/certificate/data?user_id=${userID}`;
      if (programView) endPoint = endPoint += '&program_view=true';
      const data = await apiRequest('get', false, endPoint, token);
      const user = JSON.parse(localStorage.getItem('user'));
      user.hours = totalValue;
      const doc = await generateHtmlForPdf(data, user, programView);

      const serializer = new XMLSerializer();
      const htmlString = serializer.serializeToString(doc);

      const element = doc.getElementById('certificate-download');

      convertImagesToBase64(element).then(() => {
        html2pdf()
          .from(element)
          .set({ dpi: 1200, image: { type: 'png', quality: 1 } })
          .save(`${user.first_name}-Socialcreds-Certificate.pdf`);
        setCertificateData(htmlString);
      });
    } catch (err) {
      console.log(err);
    }
  }

  if (!isLoading && certificateData.length === 0) {
    return (
      <Box sx={{ padding: 3 }}>
        <Card variant="outlined">
          <CardContent>
            <Typography variant="h5" gutterBottom>
              Hi {firstName}, these are your {parseInt(props.type) === 1 ? 'credits' : 'debits'}
            </Typography>
            <Typography variant="subtitle1" sx={{ mb: 2 }}>
              Total {parseInt(props.type) === 1 ? 'credits' : 'debits'}: {totalValue}
            </Typography>
    
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              justifyContent="flex-end"
              sx={{ mb: 3 }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                  color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                  textTransform: 'none',
                  fontFamily: 'Raleway',
                }}
                onClick={() => getCertificateData()}
              >
                Download Certificate (Event)
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                  color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                  textTransform: 'none',
                  fontFamily: 'Raleway',
                }}
                onClick={() => getCertificateData(true)}
              >
                Download Certificate (Program)
              </Button>
            </Stack>
    
            <TableContainer component={Paper} elevation={1}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Program Name</TableCell>
                    <TableCell>Event Name</TableCell>
                    <TableCell>Event Date</TableCell>
                    <TableCell>Credits Earned</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{tableBod(data, props.type, fontSize)}</TableBody>
              </Table>
            </TableContainer>
    
            <TablePagination
              component="div"
              rowsPerPageOptions={[10, 25, 100]}
              count={tableBod(data, props.type).length}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </CardContent>
        </Card>
      </Box>
    );
    
    // return (
    //   <div style={{ padding: '1vw' }}>
    //     <Grid>
    //       <Grid container spacing={2} mt={2} >
    //         <Grid item xs={12} md={8}>
    //           <Typography variant='h5' p={5} ml={5}>Hi {firstName},  These are your   {parseInt(props.type) === 1 ? 'credits' : 'debits'}</Typography>
    //           <Typography variant='h6' >
    //             {parseInt(props.type) === 1 ? 'Total credits' : 'Total debits'} :{' '}
    //             {totalValue}
    //           </Typography>
    //         </Grid>
    //         <Grid item xs={6} md={2} container justifyContent="flex-end" style={{ marginTop: 10, marginBottom: 20 }}>
    //           <Typography>
    //             <Button
    //               id="#downloadbutton"
    //               style={{
    //                 backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
    //                 fontFamily: 'Raleway',
    //                 color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
    //                 borderRadius: 5,
    //                 textTransform: 'None',
    //                 height: 40,
    //               }}
    //               variant='contained'
    //               onClick={() => { getCertificateData() }}
    //             >
    //               Download Certificate (Event)
    //             </Button>
    //           </Typography>
    //         </Grid>
    //         <Grid item container justifyContent="flex-end" xs={6} md={2} style={{ marginTop: 10, marginBottom: 20 }}>
    //           <Typography>
    //             <Button
    //               id="#downloadbutton"
    //               style={{
    //                 backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
    //                 fontFamily: 'Raleway',
    //                 color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
    //                 borderRadius: 5,
    //                 textTransform: 'None',
    //                 height: 40,
    //               }}
    //               variant='contained'
    //               onClick={() => { getCertificateData(true) }}
    //             >
    //               Download Certificate (Program)
    //             </Button>
    //           </Typography>
    //         </Grid>
    //       </Grid>
    //       <TableContainer>
    //         <Table stickyHeader aria-label='sticky table' id="credDatatable">
    //           <TableHead>
    //             <TableRow>
    //               <TableCell >
    //                 <Typography>Program name</Typography>
    //               </TableCell>
    //               <TableCell >
    //                 <Typography>Event<br></br>name</Typography>
    //               </TableCell>
    //               <TableCell >
    //                 <Typography>Event date</Typography>
    //               </TableCell>
    //               <TableCell >
    //                 <Typography>
    //                   {parseInt(props.type) === 1 ? 'Credits' : 'Debits'}{' '}
    //                 </Typography>
    //               </TableCell>
    //             </TableRow>
    //           </TableHead>
    //           <TableBody>{tableBod(data, props.type, fontSize)}</TableBody>
    //         </Table>
    //       </TableContainer>
    //       <TablePagination
    //         rowsPerPageOptions={[10, 25, 100]}
    //         component='div'
    //         count={tableBod(data, props.type).length}
    //         rowsPerPage={rowsPerPage}
    //         page={page}
    //         onPageChange={handleChangePage}
    //         onRowsPerPageChange={handleChangeRowsPerPage}
    //       />
    //     </Grid>
    //   </div>
    // );
  } else if (certificateData.length > 0) {
    return <div>  <div dangerouslySetInnerHTML={{ __html: certificateData }}></div></div>;
  } else if (isLoading) {
    return (
      <div style={{ marginTop: 20, textAlign: "center" }}>
        <img alt={'logo'} style={{ height: 350, width: 300 }} src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`} />
        <LinearProgress />
      </div>
    );
  }
}
export default DataTable;